import React from "react";
import { Clock, BadgeCheck, TrendingUp, Handshake, CalendarCheck, FileBarChart } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

const ICONS = [<Clock size={20} />, <BadgeCheck size={20} />, <TrendingUp size={20} />, <Handshake size={20} />, <CalendarCheck size={20} />, <FileBarChart size={20} />];

export function Outcomes() {
  const { t } = useI18n();
  const o = t.outcomes;
  return (
    <section id="outcomes" className="bg-background py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-accent">{o.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{o.title}</h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {o.items.map((it, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div data-testid={`outcome-${i}`}>
                <span className="grid place-items-center h-12 w-12 rounded-full bg-pine text-cream">{ICONS[i]}</span>
                <h3 className="mt-5 font-serif text-2xl">{it.t}</h3>
                <p className="mt-2 text-muted-foreground text-base leading-relaxed">{it.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
